import { createComponent as _$createComponent } from "solid-js/web";
import { CesiumProvider } from "./cesium/CesiumProvider";
import { LayerRenderer } from "./layers/LayerRenderer";
import { BaseImagery } from "./layers/BaseImageryLayer";
import { Shell } from "./ui/ShellComponent";

// Side-effect imports: register layer definitions
import "./layers/satellites";
import "./layers/ships";
import "./layers/ground";
import "./layers/planes";
export function App() {
  return _$createComponent(CesiumProvider, {
    options: {
      msaaSamples: 4,
      maximumScreenSpaceError: 16
    },
    get children() {
      return [_$createComponent(BaseImagery, {}), _$createComponent(LayerRenderer, {}), _$createComponent(Shell, {})];
    }
  });
}